"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/** Global Class  */
window.FAB_METABOX_LOCATION = Object.assign(Object.assign({}, window.FAB_METABOX_LOCATION), { 
    /**
     * Define Default Option
     * */
    defaultOptions: Object.assign(Object.assign({}, window.FAB_METABOX_LOCATION.defaultOptions), { select2: { placeholder: '--choose--' }, type: [], post_types: [] }), 
    /** Initiate Metabox Location */
    init: () => {
        /** Validate Data Before Form Submission */
        jQuery('#post').on('submit', function () {
            let invalidRule = window.FAB_METABOX_LOCATION.check_invalid_rules();
            /** Check Number of rules */
            let numberofRules = jQuery('#fab-location-rules .fab-location-rule-item').length;
            if (numberofRules == 1 && invalidRule) {
                let ruleItem = jQuery('#fab-location-rules .fab-location-rule-item').last();
                /** Rule Type */
                jQuery('.select2[name^="fab_location_type', ruleItem).val('');
                jQuery('.select2[name^="fab_location_type', ruleItem).trigger('change');
                /** Rule Operator */
                jQuery('.select2[name^="fab_location_operator', ruleItem).val('');
                jQuery('.select2[name^="fab_location_operator', ruleItem).trigger('change');
                /** Rule Value */
                jQuery('.select2[name^="fab_location_value', ruleItem).val('');
                jQuery('.select2[name^="fab_location_value', ruleItem).trigger('change');
                /** Rule Logic */
                jQuery('.select2[name^="fab_location_logic', ruleItem).val('');
                jQuery('.select2[name^="fab_location_logic', ruleItem).trigger('change');
                return true;
            }
            /** Inform User for invalid location rules */
            if (invalidRule) {
                jQuery.dialog({
                    icon: 'fas fa-times',
                    closeIcon: true,
                    animation: 'scale',
                    columnClass: 'j-small',
                    title: 'Error',
                    content: 'Please check input, there are invalid location rules!',
                });
            }
            return !invalidRule;
        });
    }, 
    /** Initialize Type Options */
    init_type_options: () => {
        /** Transform Value */
        let post_types = window.FAB_METABOX_LOCATION.post_types;
        post_types = Object.keys(post_types).sort().map(function (k, i) {
            return { id: k, text: post_types[k].label };
        });
        post_types = post_types.filter(function (k, i) {
            return (window.FAB_METABOX_LOCATION.excludes_post_types.includes(k.id)) ? false : true;
        });
        let post_taxonomies = window.FAB_METABOX_LOCATION.post_taxonomies;
        post_taxonomies = Object.keys(post_taxonomies).sort().map(function (k, i) {
            return { id: k, text: post_taxonomies[k].labels.name };
        });
        /** Assign Values */
        window.FAB_METABOX_LOCATION.defaultOptions.post_types = post_types;
        window.FAB_METABOX_LOCATION.defaultOptions.type = [
            ...window.FAB_METABOX_LOCATION.defaultOptions.type,
            {
                text: `Post`,
                children: [
                    { id: `post_type`, text: `Post Type` },
                    ...post_types.map(function (k, i) {
                        let text = k.text.substr(k.text.length - 1);
                        text = (text === 's') ? k.text.substring(0, k.text.length - 1) : k.text;
                        return { id: `single_${k.id}`, text: `Single ${text}` };
                    })
                ]
            },
            {
                text: `Taxonomy`,
                children: [
                    ...post_taxonomies.map(function (k, i) {
                        return { id: `taxonomy_${k.id}`, text: `${k.text} (${k.id})` };
                    })
                ]
            },
            {
                text: 'User',
                children: [
                    { id: `user_session`, text: `Session` },
                    { id: `user_role`, text: `Role` },
                ]
            },
            // get more from apply filters ...
            window.FAB_METABOX_LOCATION.objects
        ];
    }, 
    /**
     * Check invalid rules before form submission
     * */
    check_invalid_rules: () => {
        let invalidRule = false;
        jQuery('#fab-location-rules .fab-location-rule-item').each(function () {
            let rule;
            /** Rule Type */
            rule = jQuery('.select2[name^="fab_location_type', this);
            if (!rule.val()) {
                invalidRule = true;
                return false;
            }
            /** Rule Operator */
            rule = jQuery('.select2[name^="fab_location_operator', this);
            if (!rule.val()) {
                invalidRule = true;
                return false;
            }
            /** Rule Value */
            rule = jQuery('.select2[name^="fab_location_value', this);
            if (!rule.val()) {
                invalidRule = true;
                return false;
            }
            /** Rule Logic */
            rule = jQuery('.select2[name^="fab_location_logic', this);
            if (!rule.val()) {
                invalidRule = true;
                return false;
            }
        });
        return invalidRule;
    }, 
    /** Reload Select2 */
    reloadSelect2: (DOM, option) => {
        if (!option.selectedValue)
            option.selectedValue = DOM.val();
        if (DOM.data('select2')) {
            DOM.select2('destroy');
            DOM.empty();
        }
        DOM.select2(option);
        DOM.val(option.selectedValue);
        DOM.trigger('change');
    }, 
    /**
     * Get type comparator by type, for select2 option
     * */
    getComparatorOption: (typeValue, option) => {
        /** if type is post_type */
        if (typeValue !== undefined && typeValue) {
            if (typeValue === 'post_type') { /** Post Type */
                option.data = window.FAB_METABOX_LOCATION.defaultOptions.post_types;
            }
            else if (typeValue.includes('taxonomy_')) { /** Single Page */
                option.ajax = window.FAB_METABOX_LOCATION.getComparatorOptionTaxonomyTermAjax(typeValue);
            }
            else if (typeValue === 'user_session') { /** User Session */
                option.data = [{ id: 'user_session_logged_in', text: 'Logged In' }];
            }
            else if (typeValue === 'user_role') { /** User Session */
                option.data = window.FAB_METABOX_LOCATION.defaultOptions.user.roles;
            }
            else if (typeValue.includes('single_')) { /** Single Page */
                option.ajax = window.FAB_METABOX_LOCATION.getComparatorOptionSingleAjax(typeValue);
            }
        }
        return option;
    }, 
    /**
     * Get comparator by type, for select2 option (Ajax)
     * */
    getComparatorOptionSingleAjax: (typeValue) => {
        return {
            delay: 500,
            dataType: "json",
            url: (params) => {
                typeValue = typeValue.replace('single_', '');
                let restBase = window.FAB_METABOX_LOCATION.post_types[typeValue].rest_base;
                restBase = (restBase) ? restBase : typeValue;
                restBase += (window.FAB_PLUGIN.isNumeric(params.term)) ? `/${params.term}` : '';
                return `${window.FAB_METABOX_LOCATION.rest_url}wp/v2/${restBase}`;
            },
            data: (params) => {
                let data = { _fields: 'id,title' };
                /** Normal Search */
                if (!window.FAB_PLUGIN.isNumeric(params.term)) {
                    data = Object.assign(Object.assign({}, data), { filter: { post_status: 'publish,private' }, page: params.page || 1, search: params.term, orderby: 'title', order: 'asc' });
                }
                /** Save Params */
                window.FAB_METABOX_LOCATION.ajax_params = data;
                return data;
            },
            processResults: function (data) {
                /** Handle Pagination */
                let pagination = { more: false };
                if (window.FAB_METABOX_LOCATION.ajax_params.page <
                    this._request.getResponseHeader('X-WP-TotalPages'))
                    pagination.more = true;
                /** Grab Data */
                if (!Array.isArray(data))
                    data = [data];
                data = data.map(function (v, i) {
                    return { id: v.id, text: v.title.rendered.replace(/[^\w\s]/gi, '') };
                });
                return { results: data, pagination: pagination };
            },
        };
    }, 
    /**
     * Get comparator by type, for select2 option (Ajax)
     * */
    getComparatorOptionTaxonomyTermAjax: (typeValue) => {
        return {
            delay: 500,
            dataType: "json",
            url: (params) => {
                typeValue = typeValue.replace('taxonomy_', '');
                let restBase = window.FAB_METABOX_LOCATION.post_taxonomies[typeValue].rest_base;
                restBase = (restBase) ? restBase : typeValue;
                restBase += (window.FAB_PLUGIN.isNumeric(params.term)) ? `/${params.term}` : '';
                return `${window.FAB_METABOX_LOCATION.rest_url}wp/v2/${restBase}`;
            },
            data: (params) => {
                let data = {};
                /** Normal Search */
                if (!window.FAB_PLUGIN.isNumeric(params.term)) {
                    data = {
                        page: params.page || 1,
                        per_page: 10,
                        search: params.term
                    };
                }
                /** Save Params */
                window.FAB_METABOX_LOCATION.ajax_params = data;
                return data;
            },
            processResults: function (data) {
                /** Handle Pagination */
                let pagination = { more: false };
                if (window.FAB_METABOX_LOCATION.ajax_params.page <
                    this._request.getResponseHeader('X-WP-TotalPages'))
                    pagination.more = true;
                /** Grab Data */
                data = data.map(function (v, i) {
                    return { id: v.id, text: v.name.replace(/[^\w\s]/gi, '') };
                });
                return { results: data, pagination: pagination };
            },
        };
    } });
